var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    width: 22,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.688 7.563L11 .688l10.313 6.875M2.063 17.188h17.875v4.125H2.063v-9.625",
    strokeWidth: 1.191671
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.813 13.063h-2.75v4.124h5.5v-1.375a2.75 2.75 0 00-2.75-2.75zM17.188 13.063h-4.326a4.125 4.125 0 00-3.69 2.28l-.922 1.845h11.688v-1.375a2.75 2.75 0 00-2.75-2.75z",
    strokeWidth: 1.191671
  }))));
}
export default SvgBedroom;